import Vue from 'vue';
import Vuex from 'vuex';

import createPersistedState from 'vuex-persistedstate';

import progress from './progress'
import move from './move'
import log from './log'
import character from './character'
import oracle from './oracle'
import note from './note'

Vue.use(Vuex);

const sessionKey =
  new URL(location.href).searchParams.get('session') || 'ironsworn_default';

export default new Vuex.Store({
  plugins: [
    createPersistedState({
      key: sessionKey,
      paths: [
        "character.xp",
        "character.name",
        "character.bondTrackTicks",
        "character.stats",
        "character.vitals",
        "progress.progressTracks",
        "progress.pinnedProgressTrackUUID",
        "log.logEntries",
        "note.general"
      ],
    }),
  ],
  state: {
    session: {
      key: sessionKey,
      initialized: false,
    },

  },

  getters: {
    sessionKey(state) {
      return state.session.key;
    },

  },

  mutations: {
    initializeSession(state) {
      state.session.initialized = true;
    },
  },

  actions: {
    initializeSession({commit, dispatch}) {
      commit('initializeSession');
      dispatch('log/initializeLog', { root: true });
    },
  },

  modules: {
    progress,
    move,
    log,
    character,
    oracle,
    note,
  },
});
